import Icon from '../components/Icon.vue'

Icon.register({
  'phone-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M497.4 361.8c8.1 3.5 14.6 13.5 14.6 22.3 0 1.5-0.3 3.9-0.6 5.3l-24 104c-2.4 10.3-12.8 18.6-23.4 18.6h0c-256.1 0-464-207.5-464-464v0c0-10.5 8.3-21 18.6-23.4l104-24c1.5-0.3 3.9-0.6 5.4-0.6 8.7 0 18.7 6.5 22.1 14.5l48 112c1.1 2.5 1.9 6.7 1.9 9.4 0 6.3-4 14.6-8.8 18.6l-60.6 49.6c31.3 66.5 110.7 145.8 177.2 177.2l49.6-60.6c4-4.9 12.3-8.8 18.6-8.8 2.7 0 6.9 0.9 9.4 1.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/phone-alt.js
// module id = 1630
// module chunks = 0